module.exports = __webpack_public_path__ + "static/media/timer-left.373822ba.svg";